<template>
  <aside :class="`sidebar ${collapsed ? 'collapsed' : ''} ${mobileMenu ? 'mobile-menu-open' : ''} ${assumed ? 'assumed' : ''}`">
    <header>
      <svg @click="$router.push('/dashboard')" class="streamify-logo" width="100%" viewBox="0 0 243 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="streamify-logo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-200.000000, -78.000000)" fill="#FFFFFF">
            <g transform="translate(200.000000, 78.000000)">
              <path d="M219.193579,0 L219.193579,5.072425 L219.193579,5.072425 L216.851519,5.072425 C215.03841,5.072425 214.246513,5.83986241 213.748137,6.71125549 C213.249761,7.58264858 213.151921,8.53353717 213.151921,9.92165106 L213.151921,9.92165106 L213.151921,12.0955475 L224.657367,12.0955475 L230.160902,29.2665775 L236.370724,12.0955475 L242.256449,12.0955475 C236.783489,26.7899866 233.563921,35.3755016 232.60386,37.8520925 C231.160711,41.5700363 230.326008,43.8723486 229.292566,45.3491305 C228.259125,46.822855 226.085228,48 223.094974,48 C223.039939,48 222.987961,48 222.935983,48 L222.474298,48 C220.829352,48 219.737818,47.993885 219.193579,47.9816549 L219.193579,47.9816549 L219.193579,42.927575 L219.193579,42.927575 L221.535639,42.927575 C222.731129,42.927575 223.749283,43.0682209 224.590101,42.5759603 C225.256641,42.1876553 225.629658,41.209249 226.005733,40.19721 L226.088286,39.9709536 L226.088286,39.9709536 L226.170839,39.7446971 C226.213644,39.6315689 226.256449,39.5214982 226.299255,39.40837 C226.629467,38.5706096 226.889356,37.9071278 227.072807,37.4179247 L227.072807,37.4179247 L220.444105,17.1679725 L213.151921,17.1679725 L213.151921,36.6810625 L207.094974,36.6810625 L207.094974,8.90961208 C207.094974,3.03917447 210.024078,0 216.071852,0 L216.071852,0 L219.193579,0 Z M138.734951,11.5543665 C140.584751,11.5543665 142.251099,11.8937512 143.737053,12.569463 C145.223008,13.2451749 146.400153,14.1960634 147.271546,15.4251863 L147.271546,15.4251863 L147.751577,12.2973438 L152.848462,12.2973438 L152.848462,36.690235 L147.005542,36.690235 L147.005542,33.247468 C146.170839,34.5285687 144.972291,35.5406077 143.416014,36.2897 C141.859736,37.0357348 140.120008,37.4087521 138.199885,37.4087521 C135.940378,37.4087521 133.934646,36.8798013 132.182687,35.8218995 C130.430728,34.7639977 129.073189,33.2688706 128.113128,31.3395758 C127.153067,29.4102809 126.673036,27.163004 126.673036,24.6038601 C126.673036,22.0263711 127.180585,19.742404 128.192624,17.7611313 C129.204663,15.7798586 130.623352,14.2480413 132.448691,13.1717944 C134.277088,12.09249 136.371489,11.5543665 138.734951,11.5543665 Z M112.284349,11.5543665 C114.650869,11.5543665 116.74527,12.0557997 118.567552,13.0617237 C120.389834,14.0676476 121.79935,15.4404739 122.796102,17.1832601 C123.792853,18.9260462 124.291229,20.9256641 124.291229,23.185171 C124.291229,24.3959488 124.202561,25.3988152 124.025225,26.1998853 L124.025225,26.1998853 L105.777948,26.1998853 L105.784063,26.3527613 C105.884961,28.1322377 106.52704,29.5692719 107.7103,30.6669215 C108.927193,31.7951462 110.50793,32.3607873 112.446398,32.3607873 C113.904835,32.3607873 115.164533,32.070323 116.222435,31.4924517 C117.280336,30.9145805 118.004968,30.1104529 118.396331,29.0770113 L118.396331,29.0770113 L124.346264,29.0770113 L124.309574,29.2360023 C123.753105,31.6545003 122.404739,33.6113128 120.261418,35.1064399 C118.075291,36.6351997 115.467227,37.3995796 112.44334,37.3995796 C109.936174,37.3995796 107.725588,36.8522836 105.814638,35.7576916 C103.903688,34.6630996 102.417734,33.1343398 101.359832,31.1683547 C100.30193,29.2023696 99.7729792,26.9398051 99.7729792,24.3776037 C99.7729792,21.8001147 100.311103,19.5436652 101.38735,17.6143703 C102.463596,15.6850755 103.949551,14.1899484 105.842156,13.1320466 C107.73476,12.0833174 109.884196,11.5543665 112.284349,11.5543665 Z M56.4937894,11.5543665 C59.3739729,11.5543665 61.7038028,12.2667686 63.4832792,13.6885152 C65.2627556,15.1102618 66.1861265,16.9875788 66.2564495,19.3174088 L66.2564495,19.3174088 L60.2545385,19.3174088 L60.2545385,19.2134531 C60.2300783,18.2839671 59.8754061,17.5440474 59.1874642,16.9967514 C58.4750621,16.4280527 57.5425186,16.1437034 56.3867762,16.1437034 C55.338047,16.1437034 54.5002866,16.3699599 53.8796102,16.8255303 C53.2558762,17.2780432 52.9470667,17.9231798 52.9470667,18.7609402 C52.9470667,19.595643 53.1916683,20.1796293 53.6808714,20.5098414 C54.1700745,20.8400535 54.8855341,21.1182878 55.8272501,21.3506593 L55.8272501,21.3506593 L60.5236002,22.4177336 L60.7039939,22.4635964 C62.7311294,22.9833747 64.2384865,23.8455953 65.2321804,25.0472005 C66.2533919,26.2824384 66.7670552,27.7653354 66.7670552,29.4897764 C66.7670552,31.8899293 65.8467418,33.8131091 64.006115,35.2532008 C62.1654882,36.6932926 59.6980699,37.4148672 56.6038601,37.4148672 C53.5799732,37.4148672 51.1217275,36.7024651 49.2260654,35.2807185 C47.3304032,33.8589719 46.3122492,31.9449646 46.1716033,29.5448118 L46.1716033,29.5448118 L52.1735142,29.5448118 L52.1826868,29.6548825 C52.2774699,30.6516339 52.7085802,31.4221288 53.4821326,31.9724823 C54.2832028,32.541181 55.3044143,32.8255303 56.5488248,32.8255303 C57.7932352,32.8255303 58.7594114,32.5839862 59.4442958,32.1039557 C60.1291802,31.6239251 60.4716224,30.9298681 60.4716224,30.0217848 C60.4716224,29.187082 60.1995032,28.5755781 59.6583222,28.1933881 C59.1171412,27.8111982 58.4077967,27.5299064 57.5364036,27.3525702 L57.5364036,27.3525702 L53.4270973,26.3649914 L53.2436461,26.3221861 C51.042232,25.8024078 49.4186891,24.9493598 48.3730174,23.7630422 C47.2967705,22.5461494 46.758647,21.0815976 46.758647,19.3755016 C46.758647,17.0089815 47.6606153,15.1163768 49.4676094,13.6915727 C51.2746035,12.2667686 53.6105484,11.5543665 56.4937894,11.5543665 Z M74.997898,5.072425 L74.997898,12.098605 L81.0395567,12.098605 L81.0395567,17.17103 L74.997898,17.17103 L74.997898,26.7594114 C74.997898,28.1475253 75.0957386,29.0984139 75.5941143,29.969807 C76.09249,30.8412001 76.8843875,31.6086375 78.6974967,31.6086375 L81.0395567,31.6086375 L81.0395567,31.6086375 L81.0395567,36.6810625 L77.9178292,36.6810625 L77.9178292,36.6810625 C71.8700554,36.6810625 68.9409517,33.641888 68.9409517,27.7714504 L68.9409517,5.072425 L74.997898,5.072425 Z M203.584942,12.098605 L203.584942,36.68412 L197.341487,36.68412 L197.341487,12.098605 L203.584942,12.098605 Z M185.013568,11.5543665 C187.64915,11.5543665 189.777183,12.3646092 191.394611,13.9820371 C193.012039,15.5994649 193.825339,17.8161666 193.825339,20.6260271 L193.825339,20.6260271 L193.825339,36.6871775 L187.762278,36.6871775 L187.762278,22.0936365 C187.762278,20.3508504 187.349513,19.042232 186.520925,18.1708389 C185.692337,17.2994458 184.594688,16.8622205 183.221861,16.8622205 C181.619721,16.8622205 180.369195,17.3789413 179.470285,18.4093254 C178.571374,19.4397095 178.121919,20.7575005 178.121919,22.3565832 L178.121919,22.3565832 L178.121919,36.68412 L172.113893,36.68412 L172.113893,22.0936365 C172.113893,20.4578636 171.695012,19.1767629 170.86031,18.2533919 C170.022549,17.330021 168.875979,16.865278 167.414485,16.865278 C165.919358,16.865278 164.72081,17.3911714 163.821899,18.4399006 C162.922989,19.4886298 162.473533,20.7972482 162.473533,22.3626983 L162.473533,22.3626983 L162.473533,36.690235 L156.358494,36.690235 L156.358494,12.2942863 L161.938467,12.2942863 L162.259507,14.9420982 C162.990254,13.893369 163.980891,13.0647812 165.237531,12.4624498 C166.494172,11.8601185 167.833365,11.5543665 169.255112,11.5543665 C171.034588,11.5543665 172.627556,11.9640741 174.034015,12.7804319 C175.440474,13.5967896 176.45557,14.7188993 177.079304,16.1406459 C177.810052,14.6822091 178.858781,13.5539843 180.231607,12.7529142 C181.604433,11.9518441 183.197401,11.5543665 185.013568,11.5543665 Z M96.5962163,12.0863749 C97.3972865,12.10472 98.1616663,12.1842156 98.889356,12.327919 L98.889356,12.327919 L98.889356,17.5562775 C98.2319893,17.4859545 97.7519587,17.4492643 97.4492643,17.4492643 C95.2631378,17.4492643 93.575387,18.0577107 92.3951844,19.277661 C91.2149818,20.4976113 90.621823,22.2159373 90.621823,24.4387541 L90.621823,24.4387541 L90.621823,36.68412 L84.5098414,36.68412 L84.5098414,12.2942863 L90.0317218,12.2942863 L90.5667877,15.8226639 C90.92146,14.6118861 91.6430346,13.6885152 92.728454,13.0494936 C93.810816,12.4074145 95.1010892,12.0863749 96.5962163,12.0863749 Z M139.777565,17.0242691 C137.695395,17.0242691 136.029046,17.7060959 134.775463,19.0666921 C133.52188,20.4272884 132.895089,22.2189948 132.895089,24.4418116 C132.895089,26.6646283 133.527995,28.4624498 134.790751,29.8322186 C136.053507,31.2019874 137.698452,31.8868718 139.725588,31.8868718 C141.771068,31.8868718 143.437416,31.1928148 144.72769,29.8047009 C146.017963,28.416587 146.6631,26.6126505 146.6631,24.3898337 C146.6631,22.167017 146.036308,20.3844831 144.782725,19.042232 C143.526084,17.6938659 141.856679,17.0242691 139.777565,17.0242691 Z M112.125358,16.5686986 C110.345882,16.5686986 108.878273,17.0701319 107.72253,18.0760558 C106.566788,19.0819797 105.952226,20.4181158 105.881903,22.090579 L105.881903,22.090579 L118.075291,22.090579 C118.038601,20.3844831 117.476018,19.036117 116.381426,18.0485381 C115.286834,17.0640168 113.868144,16.5686986 112.125358,16.5686986 Z M200.460157,1.56239251 C202.829734,1.56239251 204.752914,3.48557233 204.752914,5.85515001 C204.752914,8.22472769 202.829734,10.1479075 200.460157,10.1479075 C198.090579,10.1479075 196.167399,8.22472769 196.167399,5.85515001 C196.167399,3.48557233 198.090579,1.56239251 200.460157,1.56239251 Z" id="text" fill-rule="nonzero"></path>
              <g id="icon" transform="translate(0.000000, 3.974775)">
                <path d="M20.2010319,19.5681254 C20.2010319,18.4429582 19.6384483,17.3422511 18.6111217,16.706287 L5.13357539,8.37148863 C4.60156698,8.04127651 3.99006306,7.87005542 3.36327155,7.87005542 C1.50429964,7.87005542 0,9.37435505 0,11.233327 L0,19.5681254 L0,27.9029238 C0,29.7618957 1.50429964,31.2661953 3.36327155,31.2661953 C3.98700554,31.2661953 4.60156698,31.0919167 5.13357539,30.7647621 L18.6111217,22.4299637 C19.6384483,21.7939996 20.2010319,20.6932926 20.2010319,19.5681254 Z" id="Path"></path>
                <path d="M29.352188,0 L16.5778712,0 C13.8750239,0 11.6858399,2.18918402 11.6858399,4.89203134 C11.6858399,6.55226448 12.5266577,8.09936939 13.9208867,9.00133766 L22.326008,14.4314925 C24.1330021,15.5994649 25.1144659,17.5623925 25.1175234,19.5681254 C25.1144659,21.5708007 24.1330021,23.5337283 22.326008,24.7047583 L13.9239442,30.1379706 C12.5297153,31.0399388 11.6888974,32.5870438 11.6888974,34.2472769 C11.6888974,36.9501242 13.8780814,39.1393082 16.5809287,39.1393082 L29.352188,39.1393082 C32.0550354,39.1393082 34.2442194,36.9501242 34.2442194,34.2472769 L34.2442194,19.5681254 L34.2442194,4.89203134 C34.2442194,2.18918402 32.0519778,0 29.352188,0 Z" id="Path"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <div class="mobile-menu-toggle" @click="mobileMenu = !mobileMenu"><span></span></div>
    </header>
    <section>
      <nav>
        <a v-for="(item, index) in primaryMenuItems" :href="item.path" :key="index" :class="`menu-item icon-${item.meta.menu.icon} ${item.meta.menu.highlight.indexOf($route.meta.name) >= 0 ? 'selected' : ''}`" @click.prevent="handleLink($event, item.path); mobileMenu = false;">
          <span>{{ item.meta.menu.i18n ? $t(item.meta.menu.i18n) : item.meta.menu.title }}</span>
        </a>
      </nav>
      <nav>
        <a v-for="(item, index) in secondaryMenuItems" :href="item.path" :key="index" :class="`menu-item icon-${item.meta.menu.icon} ${item.meta.menu.highlight.indexOf($route.meta.name) >= 0 ? 'selected' : ''}`" @click.prevent="handleLink($event, item.path); mobileMenu = false;">
          <span>{{ item.meta.menu.i18n ? $t(item.meta.menu.i18n) : item.meta.menu.title }}</span>
        </a>
      </nav>
      <div class="mt-a"></div>
      <NotificationsMenuBar />
      <nav class="m-b-1">
        <div :class="`current-user ${assumed || assumeParam ? 'assumed' : ''}`" v-if="account">
          <div class="inner">
            <div class="account-char">
              <template v-if="assumed || assumeParam">
                <i class="icon-hardhat" />
              </template>
              <template v-else>
                {{ account.name[0] }}
              </template>
              <span v-if="assumed || assumeParam">!</span>
            </div>
            <div class="info">
              <p class="package" v-if="accountSettings.subscription && (accountSettings.subscription.active || accountSettings.subscription.trial)">
                {{ accountSettings.stripe_plan.product }}
              </p>
              <p class="account" :title="account.name">
                <span>{{ account.name }}</span>
                <span :class="`account-id ml-a ${copiedID ? 'copied' : ''}`" @click="copyID(account.id)">#{{ account.id }}</span>
              </p>
              <p class="user" :title="user.email">{{ user.email }}</p>
            </div>
            <template v-if="hasAccountsToAssume">
              <div class="assume" @click="toggleAssume = true">
                <i class="icon-hardhat" />
              </div>
            </template>
          </div>
          <div class="unassume" v-if="assumed || assumeParam" @click="unassumeAccount()">
            Unassume
          </div>
          <AssumeAccount :show="toggleAssume" @hide="toggleAssume = false" />
        </div>
        <a href="https://support.streamify.io" target="_blank" class="menu-item icon-support-24">
          <span>Support</span>
        </a>
        <a href="#" @click.prevent="logout()" class="menu-item icon-arrow-back">
          <span>Logout</span>
        </a>
      </nav>
    </section>

    <div class="collapse-button" @click.prevent="collapse">
      <i :class="`icon-${collapsed ? 'expand' : 'collapse'}`" />
    </div>
  </aside>
</template>

<script>

import AssumeAccount from '@/components/Super/Assume.vue';
import NotificationsMenuBar from '@/components/Notifications/MenuBar.vue';

export default {
  components: {
    AssumeAccount,
    NotificationsMenuBar,
  },
  computed: {
    notifications() {
      return this.$store.getters['Notifications/get']('top-bar').length;
    },
    accountId() {
      return this.$store.getters['AccountManager/account']?.id;
    },
    /**
     * Return boolean if something is uploading
     * @returns {Boolean}
     */
    uploading() {
      return this.$store.getters['Upload/uploading'];
    },
    /**
     * Return boolean if the menu is collapsed or not
     * @returns {Boolean}
     */
    collapsed() {
      return this.$store.getters['Theme/sidebarCollapsed'];
    },
    /**
     * Return a list of primary menu items that the user has access to
     * @returns {Array}
     */
    primaryMenuItems() {
      return this.$router.options.routes.filter(route => route.meta && route.meta.menu && this.checkConditions(route.meta.conditions) && route.meta.permission.includes(this.user.permission_id) && route.meta.menu.primary).sort((a, b) => a.meta.menu.order - b.meta.menu.order);
    },
    /**
     * Return a list of secondary menu items that the user has access to
     * @returns {Array}
     */
    secondaryMenuItems() {
      return this.$router.options.routes.filter(route => route.meta && route.meta.menu && this.checkConditions(route.meta.conditions) && route.meta.permission.includes(this.user.permission_id) && !route.meta.menu.primary).sort((a, b) => a.meta.menu.order - b.meta.menu.order);
    },
  },
  methods: {
    async logout() {
      if (this.uploading) {
        const willAbort = await swal({
          title: this.$t('common.are_you_sure'),
          text: this.$t('video.upload_logout'),
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        });
        if (!willAbort) {
          return;
        }
      }

      this.$store.commit('Notifications/clearAll');
      const loggedOut = await this.$store.dispatch('User/logout');
      if (loggedOut) {
        this.$router.push('/login');
      }
    },
    /**
     * Checks condition on a field
     * @returns {Boolean}
     */
    checkConditions(conditions) {
      let bool = true;
      if (conditions) {
        for (let i = 0; i < conditions.length; i += 1) {
          switch (conditions[i].type) {
            case 'is':
              if (this[conditions[i].field] !== conditions[i].value) {
                bool = false;
              }
              break;
            case 'contains':
              if (!this[conditions[i].field].includes(conditions[i].value)) {
                bool = false;
              }
              break;
            case 'includes':
              if (!conditions[i].value.includes(this[conditions[i].field])) {
                bool = false;
              }
              break;
            default:
              break;
          }
        }
      }

      return bool;
    },
    /**
     * Collapse menu
     * @returns {Void}
     */
    collapse() {
      this.$store.dispatch('Theme/sidebarCollapse', !this.collapsed);
    },
    /**
     * Unassume from account
     * @returns {Void}
     */
    unassumeAccount() {
      this.$store.dispatch('AccountManager/unassumeAccount');
    },
    /**
     * Copy account-id
     * @returns {Void}
     */
    copyID(id) {
      clearTimeout(this.copyTimer);
      window.Clipboard.copy(id);
      this.copiedID = true;
      this.copyTimer = setTimeout(() => {
        this.copiedID = false;
      }, 500);
    },
  },
  data() {
    return {
      mobileMenu: false,
      toggleAssume: false,
      copiedID: false,
      hasAccountsToAssume: false,
    };
  },
  watch: {
    user: {
      immediate: true,
      async handler(u) {
        if (u && this.assumable) {
          const { total } = await this.$store.dispatch('AccountManager/getChildAccounts', {
            per_page: 2,
          });
          if (total > 1) {
            this.hasAccountsToAssume = true;
          } else {
            this.hasAccountsToAssume = false;
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  .collapse-button {
    align-items: center;
    background: #FBFCFF;
    border-radius: 0 6px 6px 0;
    position: absolute;
    right: -22px;
    top: calc(50% - 32px);
    box-shadow: 0 1px 2px 0 rgb(22 67 201 / 20%), 0 0 1px 1px rgb(22 67 201 / 20%);
    display: none;
    height: 64px;
    width: 22px;

    &:hover {
      cursor: pointer;
    }

    i {
      color: var(--color-cta-blue);
      font-size: 22px;
      display: inline-block;
    }
  }

  header {
    background-color: #1643c9;
    display: flex;
    height: 56px;
    padding: 0 0 0 16px;
    align-items: center;

    .streamify-logo {
      width: 142px;
    }

    .mobile-menu-toggle {
      align-items: center;
      border-left: 1px solid #1E4EDC;
      display: flex;
      height: 56px;
      margin-left: auto;
      justify-content: center;
      width: 64px;
      z-index: 1;

      span {
        background-color: white;
        border-radius: 2px;
        height: 4px;
        position: relative;
        width: 24px;

        &:before, &:after {
          content: "";
          background-color: white;
          height: 4px;
          width: 24px;
          position: absolute;
          border-radius: 2px;
        }

        &:before {
          top: -8px;
        }

        &:after {
          top: 8px;
        }
      }

      &:hover {
        cursor: pointer;
      }
    }
  }

  .assumed-to {
    align-items: center;
    background-color: white;
    display: flex;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(165,179,194,0.20), 0 0 1px 0 rgba(165,179,194,0.50);
    padding: 8px 16px 8px 12px;
    height: 40px;

    .account-id {
      color: #868B97;
      font-size: 12px;
      transition: color .3s;
      text-overflow: unset;
      overflow: unset;
      font-family: Menlo, Consolas, monospace;

      &.copied {
        color: #1643C9;
      }
    }

    i {
      color: #868B97;
      font-size: 22px;
      margin-right: 8px;
    }

    .assumed {
      align-items: center;
      padding-right: 12px;
      display: flex;
      min-width: 0;

      span {
        margin-right: 5px;

        &:nth-child(1) {
          color: #868B97;
        }

        &:nth-child(2) {
          color: #2F2F2F;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .unassume {
      color: #1643C9;
      margin-left: auto;
    }
  }

  section {
    background-color: #1643c9;
    display: flex;
    flex-direction: column;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow: auto;
    position: fixed;
    right: 0;
    top: 56px;
    bottom: 0;
    right: calc(0% - var(--sidebar-width));
    transition: right .3s;
    width: var(--sidebar-width);

    &::-webkit-scrollbar {
      display: none;
    }

    nav {
      padding: 8px 8px 0 8px;

      &:first-child {
        &:after {
          content: "";
          background-color: var(--color-sidebar-border);
          height: 1px;
          width: 100%;
          display: block;
          margin-top: 8px;
        }
      }

      .current-user {
        margin-bottom: 5px;
        .inner {
          display: flex;
          align-items: center;
          padding: 5px;
        }
        .info {
          .package {
            color: white;
            font-size: 12px;
            text-transform: capitalize;
            font-weight: 500;
          }
        }

        &.assumed {
          background-color: white;
          border-radius: 4px;

          .assume {
            display: none;
          }

          .info {
            .package {
              color: var(--color-cta-green);
            }
            .account, .user {
              color: black;
            }

            .account .account-id {
              color: black;
              &.copied {
                color: rgba(86, 86, 86, 0.5);
              }
            }
          }

          .account-char {
            background-color: #FFD54C;
            color: black;
            line-height: 46px;
          }
        }

        .unassume {
          border-top: 1px solid #EEF1F6;
          background-color: white;
          padding: 5px;
          transition: background-color .3s;
          border-radius: 0 0 4px 4px;
          text-align: center;
          color: #0060FF;
          font-size: 12px;
          font-weight: 500;

          &:hover {
            cursor: pointer;
            background-color: #f5f5f5;
          }
        }

        .account-char {
          text-transform: uppercase;
          background-color: #309C44;
          border-radius: 20px;
          color: #C4E4CA;
          display: flex;
          font-weight: 500;
          line-height: 42px;
          height: 40px;
          min-width: 40px;
          min-height: 40px;
          justify-content: center;
          font-size: 26px;
          width: 40px;

          span {
            display: none;
          }
        }

        .info {
          margin: 0 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;

          .account {
            font-weight: 500;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 20px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: flex;

            span {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .account-id {
              color: white;
              font-size: 12px;
              transition: color .3s;
              text-overflow: unset;
              overflow: unset;
              font-family: Menlo, Consolas, monospace;
              padding-left: 10px;

              &.copied {
                color: rgba(255, 255, 255, .5);
              }

              &:hover {
                cursor: pointer;
              }
            }
          }
          .user {
            color: #7AD6FF;
            font-size: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .assume {
          min-width: 40px;
          min-height: 40px;
          height: 40px;
          width: 40px;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, .31);
          margin-left: auto;
          font-size: 26px;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(255, 255, 255, 0);
          transition: background-color .3s;

          &:hover {
            cursor: pointer;
            background-color: rgba(255, 255, 255, .31);
          }
        }
      }

      .menu-item {
        align-items: center;
        display: flex;
        border-radius: 5px;
        font-size: 14px;
        height: 44px;
        position: relative;
        outline: none;
        color: white;

        &:before {
          padding: 0 6px 0 10px;
          font-size: 30px;
          transform: scale(.8);
        }

        &:hover:not(.selected) {
          &:before {
            margin-right: 4px;
            transform: scale(1);
            transition: 0.4s all;
          }
        }

        span {
          font-size: 15px;
          font-weight: 500;
        }

        &:hover, &:focus {
          background-color: var(--color-sidebar-hover);
          cursor: pointer;
        }

        &.selected {
          background-color: var(--color-sidebar-hover);
        }

        @media (min-width: 768px) {
          font-size: 16px;

          i {
            font-size: 24px;
          }
        }

        &.focus, &.selected, &.hover {
          .subitems {
            margin-top: 8px;
            a {
              line-height: 1;
              padding: 8px;
            }
          }
        }
      }
    }
  }

  &.mobile-menu-open {
    section {
      right: 0%;
    }
  }

  @media (min-width: 1024px) {
    background-color: #1643c9;
    bottom: 0;
    display: flex;
    flex-direction: column;
    right: unset;
    transition: width .3s;
    width: var(--sidebar-width);

    .collapse-button {
      display: flex;
    }

    .assumed-to {
      display: none;
    }

    header {
      border-bottom: 1px solid #3258CE;
      height: 80px;
      padding: 0 36px 0 32px;

      .streamify-logo {
        width: 100%;
      }

      .mobile-menu-toggle {
        display: none;
      }

      .streamify-logo {
        height: 40px;

        #text {
          transition: opacity .2s;
        }
        #icon {
          transition: transform .3s;
        }
      }
    }

    section {
      flex: 1;
      position: relative;
      right: unset;
      top: unset;
      width: 100%;
    }

    &.collapsed {
      width: var(--sidebar-width-collapsed);

      header {
        padding-left: 0;
        padding-right: 0;

        .streamify-logo {

          #text {
            opacity: 0;
          }

          #icon {
            transform: translate(calc(50% - 40px), -30px) scale(2.5);
          }
        }
      }

      nav {
        .current-user {
          &, &.assumed {
            background-color: unset;

            .inner {
              justify-content: center;
              padding: 5px 0;
            }
          }

          .account-char {
            position: relative;

            span {
              display: block;
              height: 12px;
              width: 12px;
              position: absolute;
              top: -6px;
              left: 0;
              background-color: red;
              color: white;
              border-radius: 6px;
              font-size: 10px;
              line-height: 12px;
              text-align: center;
            }
          }

          .info {
            display: none;
          }

          .assume {
            display: none;
          }

          .unassume {
            display: none;
          }
        }
        .menu-item {
          padding: 0 6px;
          &:before {
            padding: 0;
          }

          &:hover:not(.selected) {
            &:before {
              margin-right: 0;
            }
          }
          span {
            display: none;
          }
        }
      }
    }
  }
}
</style>
